import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  Box,
  Typography,
  Paper,
  Pagination,
  Button,
  Tooltip,
  Grid,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import DataTable from "../../Requirement/components/common/ReusableTable";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
// Assuming RemarksThread is imported from the appropriate path
import RemarksThread from "./component/RemarksThread";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  fetchData,
  postQuery,
  uploadFileToS3Path, searchfetchQueries
} from "../../../services/BackendServices";
import config from "../../../aws-exports";
import AlertModal from "../../Requirement/components/common/AlerModel";
import { useLoading } from "../../../context/LoadingContext";
const KycComponent = (mode = "Buyer") => {
  const navigate = useNavigate();
  const [kycData, setKycData] = useState([]);

  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  let bucketfolder = "public/media/amtpl";
  const filePath = `${bucketfolder}/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  const [searchValues, setSearchValues] = useState({
    idNumber: "",
    status: "",
  });
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const { setLoading, loading } = useLoading();
  const [error, setError] = useState(null);
  const [activeUser, setActiveUser] = useState("");
  const [activeUserName, setActiveUserName] = useState("");

  // New states for image modal
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const statusOptions = ["Pending", "Approved"];

  // Fetch KYC data from API
  const fetchKycData = useCallback(async () => {
    
    setError(null);
    console.log('searchValues@@', searchValues);
    try {
      setLoading(true);
      const userKycs = await fetchData({
        target: "listUserKYCAdmin",
        userOrder: "CreatedAt DESC",
        rowStart,
        pageSize,
        filterTerms: {
          UserType: mode.mode,
          IdNumberPartial: searchValues.idNumber || "",
          Status: searchValues.status || "",
        },
      });

      // Assuming userKycs is { items: [...], total: ... }
      const fetchedData = userKycs.items || [];
      const buyerData = fetchedData.filter((item) => item.UserType === "Buyer");
      const globalData = fetchedData.filter(
        (item) => item.UserType === "GlobalPartner"
      );

      const modifiedItems = (mode.mode === "Buyer" ? buyerData : globalData || fetchedData).map((item) => ({
          ...item,
          id: item.UserKycID, // Add id property with value from RequirementsID
        }));
      setTotalItems(userKycs.total || fetchedData.length);
      setKycData(fetchedData);
      setFilteredData(modifiedItems);
    } catch (err) {
      console.error("Error fetching KYC data:", err);
      setError("Failed to fetch KYC data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [rowStart, pageSize, searchValues,mode]);

  const fields = [
    // {
    //   name: "idNumber",
    //   label: "ID Number",
    //   type: "text",
    //   onChange: (value) =>
    //     setSearchValues((prev) => ({ ...prev, idNumber: value })),
    //   value: searchValues.idNumber,
    // },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: statusOptions.map((status) => ({
        value: status,
        label: status,
      })),
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, status: value })),
      value: searchValues.status,
    },
  ];

  const handleSearch = useCallback((newSearchValues) => {
    setSearchValues(newSearchValues);
    setRowStart(0);
  }, []);

  const handlePageChange = (event, newPage) => {
    const newRowStart = (newPage - 1) * pageSize;
    setRowStart(newRowStart);
  };

  const handleReviewClick = async (row) => {
    setLoading(true);
    setError(null);
    try {
      // const response = await fetchData({
      //   target: "getUserKyc",
      //   UserKycID: row.UserKycID,
      // });

      // Parse the nested JSON string in body.items
      let kycSettings = row;

      // Map API response to the selectedRow format
      const detailedRow = {
        id: kycSettings.UserKycID,
        emailId: kycSettings.EmailID,
        idType: kycSettings.IdType,
        idNumber: kycSettings.IdNumber,
        expiryDate: kycSettings.ExpiryDate ? kycSettings.ExpiryDate.split('T')[0] : '',
        tin: kycSettings.TinTaxIDNumber || '',
        taxCountry: kycSettings.TaxResidencyCountry || '',
        pepConfirm: true, // Assuming confirmed if submitted
        verifyConfirm: true, // Assuming confirmed if submitted
        status: kycSettings.Status,
        createdAt: kycSettings.CreatedAt,
        documents: [
          kycSettings.UploadFrontOfID
            ? {
              type: "Front of ID",
              url: kycSettings.UploadFrontOfID,
            }
            : null,
          kycSettings.LiveSelfiePhoto
            ? {
              type: "Selfie Photo",
              url: kycSettings.LiveSelfiePhoto,
            }
            : null,
        ].filter(Boolean),
      };

      setSelectedRow(detailedRow);
      setUpdatedStatus(detailedRow.status);
    } catch (err) {
      console.error("Error fetching detailed KYC data:", err);
      setError("Failed to fetch detailed KYC data. Please try again.");
    } finally {
      setLoading(false);
    }
    setActiveTab(0);
  };

  const handleRowClick = (row) => {
    console.log(row)
    handleReviewClick(row);
  };

  const handleCloseReview = () => {
    setSelectedRow(null);
    setUpdatedStatus("");
    setActiveTab(0);
  };

  const handleUpdateStatus = async () => {
    if (!selectedRow || updatedStatus === selectedRow.status) {
      // No change or no row selected
      return;
    }

    setLoading(true);
    setError(null);
    try {
      // Prepare the update input based on the selectedRow mapping (reverse of fetch)
      // Only updating Status and DateOfApproval if Approved; assuming Remarks handled separately
      const currentDate = dayjs().format("YYYY-MM-DD");
      const userKycInput = {
        UserKycID: selectedRow.id,
        EmailID: selectedRow.emailId,
        IdType: selectedRow.idType,
        IdNumber: selectedRow.idNumber,
        UploadFrontOfID: selectedRow.documents[0] ? selectedRow.documents[0].url.split('/').pop() : '',
        ExpiryDate: selectedRow.expiryDate,
        LiveSelfiePhoto: selectedRow.documents[1] ? selectedRow.documents[1].url.split('/').pop() : '',
        TinTaxIDNumber: selectedRow.tin,
        TaxResidencyCountry: selectedRow.taxCountry,
        Status: updatedStatus,

      };

      await postQuery({
        target: "updateUserKyc",
        userKycInput,
      });

      // Update local state optimistically
      selectedRow.status = updatedStatus;
      selectedRow.dateOfApproval = userKycInput.DateOfApproval;

      fetchKycData();

      setModal({
        show: true,
        type: "success",
        title: "Success!",
        message: "KYC status updated successfully.",
        autoClose: false,
      });
    } catch (err) {
      console.error("Error updating KYC status:", err);
      setError("Failed to update status. Please try again.");
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: err.message || "Failed to update status. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    let bgColor = "",
      textColor = "";
    switch (status) {
      case "Pending":
        bgColor = "#fef3c7";
        textColor = "#b45309";
        break;
      case "Approved":
        bgColor = "#d1fae5";
        textColor = "#065f46";
        break;
      case "Verified":
        bgColor = "#d1fae5";
        textColor = "#065f46";
        break;
      default:
        bgColor = "#f3f4f6";
        textColor = "#374151";
    }
    return (
      <Box
        sx={{
          backgroundColor: bgColor,
          color: textColor,
          padding: "4px 10px",
          borderRadius: "999px",
          fontSize: "0.75rem",
          fontWeight: 500,
          display: "inline-block",
        }}
      >
        {status === 'Pending' ? 'In Review' : status}
      </Box>
    );
  };

  const paginatedData = filteredData.slice(rowStart, rowStart + pageSize);

  const columns = [
    { id: "IdType", numeric: false, label: "ID Type" },
    // { id: "IdNumber", numeric: false, label: "ID Number" },
    { id: "EmailID", numeric: false, label: "Email" },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Submitted",
      renderCell: (row) =>
        row.CreatedAt
          ? dayjs(row.CreatedAt).format("DD-MM-YYYY")
          : "",
    },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => getStatusBadge(row.Status),
    },
  ];

  const pageCount = Math.ceil(totalItems / pageSize);
  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const renderDisplayField = (label, value) => (
    <div className="col-md-6">
      <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
        {label}
      </label>
      <div className="p-2 border rounded bg-light">
        <p className="mb-0">{value || "N/A"}</p>
      </div>
    </div>
  );

  const renderBooleanField = (label, value, required = false) => {
    const id = label.toLowerCase().replace(/[^a-z0-9]/g, '-');
    return (
      <div className="col-md-6">
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id={id}
            checked={value}
            disabled
          />
          <label className="form-check-label" htmlFor={id}>
            {label} {required ? '*' : ''}
          </label>
        </div>
      </div>
    );
  };
  const renderBooleanFieldCheckbox = (label, value, required = false) => {
    const id = label.toLowerCase().replace(/[^a-z0-9]/g, '-');
    return (
      <div className="col-md-12">
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id={id}
            checked={value}
            disabled
          />
          <label className="form-check-label" htmlFor={id}>
            {label} {required ? '*' : ''}
          </label>
        </div>
      </div>
    );
  };

  // Updated renderDocumentField for general documents (e.g., selfie with preview)
  const renderDocumentField = (label, doc) => {
    const fullImageUrl = doc ? `${fileUrl}${doc.url}` : null;
    const isSelfie = label === "Selfie Photo"; // Only preview for selfie
    const isImage = doc && /\.(jpg|jpeg|png|gif|webp)$/i.test(doc.url); // Image check

    return (
      <div className="col-md-6">
        <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
          {label}
        </label>
        <div className="p-2 border rounded bg-light d-flex justify-content-between align-items-center">
          {doc ? (
            <>
              {isSelfie && isImage ? (
                <Tooltip title="Full image" placement="top" arrow>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={fullImageUrl}
                      alt={doc.type}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedImageUrl(fullImageUrl);
                        setImageModalOpen(true);
                      }}
                      onError={(e) => {
                        // Fallback to 100px text placeholder if image fails
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div
                      style={{
                        display: "none",
                        width: "100px",
                        height: "100px",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      Image not available
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <p className="mb-0 text-muted">Document available</p>
              )}
            </>
          ) : (
            <p className="mb-0 text-muted">N/A (No document uploaded)</p>
          )}
        </div>
      </div>
    );
  };

  // New render function for Front of ID with filename left and view button right without border
  const renderFrontDocumentField = (label, doc) => {
    const fullImageUrl = doc ? `${fileUrl}${doc.url}` : null;
console.log(doc)
    return (
      <div className="col-md-6">
        <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
          {label}
        </label>
        <div className="p-2 border rounded bg-light d-flex justify-content-between align-items-center">
          {doc ? (
            <>
              {/* <p className="mb-0 text-muted flex-grow-1 me-2">{doc.url}</p> */}
              <Button
                variant="text"
                size="small"
                onClick={() => window.open(fullImageUrl, '_blank')}
                sx={{ 
                  textTransform: 'none',
                  minWidth: 'auto',
                  padding: '0px 8px'
                }}
              >
                View Document
              </Button>
            </>
          ) : (
            <p className="mb-0 text-muted">N/A (No document uploaded)</p>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        } else {
          const email = user.attributes.email;
          const usrname = user.attributes.given_name;
          setActiveUser(email);
          setActiveUserName(usrname);
        }
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  // Fetch data on component mount and when dependencies change
  useEffect(() => {
    fetchKycData();
  }, [fetchKycData, searchValues]);
  const downloadCSV = async () => {
    setLoading(true);
    try {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      let dataToExport = [];
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listUserKYCAdmin",
          userOrder: "UserKycID",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { UserType: mode.mode },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allKybData] = await Promise.all([
          searchfetchQueries({
            target: "listUserKYCAdmin",
            userOrder: "UserKycID",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: { UserType: mode.mode },
          }),
        ]);
        dataToExport = allKybData;
        console.log("UserKycID@@", allKybData);

      }

      let fileName = `${mode.mode}_KYC_Data_${dayjs().format("YYYYMMDD")}`;
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.error("Error loading data: ", error);
    } finally {
      setLoading(false);
    }

  };
  return (
    <div className="container">
      <style>{`
        .form-check-label {
          margin-left: 8px;
        }
        .form-check-input:checked {
          background-color: #ff9800;
          border-color: #ff9800;
        }
        .form-check-input:focus {
          border-color: #ff9800;
          box-shadow: 0 0 0 0.2rem rgba(255, 152, 0, 0.25);
        }
      `}</style>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Paper elevation={2} sx={{ p: 3 }}>
        <div className="search-filter4">
          <div className="title4">
            <div className="head-text">{mode.mode} KYC</div>{" "}
            {/* Fixed: Single braces */}
          </div>
          <div className="filter4">
            <SearchFilter fields={fields} onSearch={handleSearch} />
          </div>
          <div className="download-csv">
            <button className="submit-btn-more" onClick={downloadCSV}>
              Download Data(XLSX)
            </button>
          </div>
        </div>

        <div className="table-content6">
          <DataTable
            columns={columns}
            data={paginatedData}
            selectedRows={selectedRow ? [selectedRow.id] : []}
            onRowClick={handleRowClick}
            initialOrderBy="CreatedAt"
            
          />
        </div>
        <div className="pagination mt-6 flex justify-center">
          <Pagination
            count={pageCount}
            page={currentPage}
            onChange={handlePageChange}
            sx={{
              marginBottom: "10px",
              "& .MuiPaginationItem-root": {
                backgroundColor: "#f0f0f0",
                "&.Mui-selected": {
                  backgroundColor: "#de6b14",
                  color: "#fff",
                },
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                  color: "#de6b14",
                },
              },
            }}
          />
        </div>
      </Paper>

      {selectedRow && (
        <Paper elevation={2} sx={{ p: 4, mt: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <div className="review-text">
              <b>KYC Verification Review:</b>  {selectedRow.idType}
            </div>
            <div className="d-flex gap-2 align-items-center">
              <button className="submit-btn-more" onClick={handleUpdateStatus}>
                Submit
              </button>

              <button className="submit-btn-more" onClick={handleCloseReview}>
                Cancel
              </button>
            </div>
          </Box>
          <>
            <div className="container-fluid">
              <div className="row mb-3">
                <div className="col-12">
                  <div
                    className="d-flex justify-content-between align-items-center p-2"
                    style={{
                      backgroundColor:
                        selectedRow.status === "Approved"
                          ? "#d1fae573"
                          : "#fef3c750",
                      color:
                        selectedRow.status === "Approved"
                          ? "#065f46"
                          : "#b45309",
                      borderLeft:
                        selectedRow.status === "Approved"
                          ? "3px solid #00b658fb"
                          : "3px solid #b69203f7",
                      borderRadius: "5px",
                    }}
                  >
                    <span
                      className="p-1 px-2 rounded"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Current Status: {getStatusBadge(selectedRow.status)}
                    </span>
                    <div className="d-flex gap-2">
                      {/* <button className="btn btn-outline-warning" style={{ textTransform: 'none' }}>
                                                Request Clarification
                                            </button> */}
                    </div>
                  </div>
                </div>
              </div>

              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                sx={{ mb: 2, "& .MuiTabs-indicator": { display: "none" } }}
              >
                <Tab
                  label="KYB Verification Information"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />

                <Tab
                  label="Remarks"
                  disabled={selectedRow.Status === 'Approved'}
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
              </Tabs>

              {/* --- Personal Information Tab --- */}
              {activeTab === 0 && (
                <Box className="tab-content">
                  <div className="card">
                    <div className="row" style={{ marginBottom: "10px" }}>
                      <div className="col-md-6">
                        <label
                          className="form-label"
                          style={{ fontWeight: 500, color: "#666" }}
                        >
                          Status
                        </label>
                        <select
                          value={updatedStatus}
                          onChange={(e) => setUpdatedStatus(e.target.value)}
                          className="form-select"
                        >
                          <option value="Pending">Pending</option>
                          <option value="Approved">Approved</option>
                        </select>
                      </div>
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "ID Type",
                        selectedRow.idType
                      )}
                      {renderFrontDocumentField(
                        "ID Type Document",
                        selectedRow.documents[0]
                      )}
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Expiry Date",
                        selectedRow.expiryDate
                          ? dayjs(selectedRow.expiryDate).format("DD/MM/YYYY")
                          : ""
                      )}
                      {renderDocumentField(
                        "Selfie Photo",
                        selectedRow.documents[1]
                      )}
                    </div>
                    <div className="border-bottom-1" style={{ marginBottom: "10px" }}></div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "TIN / Tax ID Number",
                        selectedRow.tin
                      )}
                      {renderDisplayField(
                        "Tax Residency Country",
                        selectedRow.taxCountry
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "5px", marginTop: "18px" }}>
                      {renderBooleanFieldCheckbox(
                        "I confirm the information is accurate and I’m not a politically exposed person (PEP).",
                        selectedRow.pepConfirm
                      )}

                    </div>
                    <div className="row" >

                      {renderBooleanFieldCheckbox(
                        "I authorize verification of my identity for compliance purposes.",
                        selectedRow.verifyConfirm
                      )}
                    </div>
                  </div>



                </Box>
              )}



              {/* --- Remarks Tab --- */}
              {activeTab === 1 && (
                <Box className="tab-content">
                  <RemarksThread
                    kycId={selectedRow.id}
                    currentUserId={activeUser}
                    currentUserName={activeUserName}
                  />
                </Box>
              )}
            </div>
          </>
        </Paper>
      )}

      {/* Image Modal */}
      {imageModalOpen && (
        <Dialog
          open={imageModalOpen}
          onClose={() => setImageModalOpen(false)}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              width: "450px",
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>
            <IconButton
              aria-label="close"
              onClick={() => setImageModalOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 2, display: "flex", justifyContent: "center" }}>
            <img
              src={selectedImageUrl}
              alt="Full Size Selfie"
              style={{
                width: "400px",
                height: "400px",
                objectFit: "contain",
                borderRadius: 1,
              }}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default KycComponent;